export default {
  CANCELED: 'upcomingAppointments.status.canceled',
  COMPLETE: 'upcomingAppointments.status.complete',
  CONFIRMED: 'upcomingAppointments.status.confirmed',
  INCOMPLETE: 'upcomingAppointments.status.incomplete',
  RESCHEDULED: 'upcomingAppointments.status.rescheduled',
  SCHEDULED: 'upcomingAppointments.status.scheduled',
};
